export const shallowEqual = (object1, object2) => {
    const keys1 = Object.keys(object1);

    for (let key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }
    return true;
}